import { CapacityConflictType } from '../types'

export default function getCapacityConflictType(
  allProductsBlocked: boolean,
): CapacityConflictType {
  return allProductsBlocked
    ? CapacityConflictType.AllProductsBlocked
    : CapacityConflictType.SomeProductsBlocked
}
